import HomeSearch from "../../components/elements/HomeSearch"
import SearchCapsules from "../../components/elements/SearchCapsules"
import Navbar from "../../layout/Navbar"
import hero from "../../assets/images/blogs.png";
import namaste from "../../assets/images/namaste.png";
import BlogCard from "../../components/cards/BlogCard";
import { useFetch } from "../../hooks/useFetch";
import { getAllBlogs } from "../../apis";
import useWidth from "../../hooks/useWidth";
import BlogsMobile from '../mobile/Blogs'
import { useState } from "react";
import Icon from "../../components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../components/elements/Loader";



export default () => {
    const [fitlers, setFilters] = useState({ search: null })
    const [blogs,,loading] = useFetch(getAllBlogs, [], fitlers)
    const width = useWidth()

    return(
        <>
            <Loader loading={loading} />
            {width < 992 ? <BlogsMobile blogs={blogs} fitlers={fitlers} setFilters={setFilters} /> : 
                <>
                    <Navbar />
                    <div className="hero-section ">
                        <img src={hero} className="w-100 h-100 hero-img bg-backdrop" alt="" />
                        <div
                            className=" hero-inner d-flex justify-content-center  flex-column"
                            style={{ position: "relative" }}
                        >
                            <div className="d-flex justify-content-center align-items-center">
                                <img src={namaste} alt="" />
                            </div>
                            <div className="d-flex w-100 justify-content-center">
                                <div className="d-flex  w-100 flex-column mt-4">
                                    <div className="w-100 d-flex justify-content-center">
                                        <HomeSearch placeholder={"Search for Topic or Question"} onSearch={ search => setFilters({ search })} />
                                    </div>

                                    <div className="mt-3 d-flex justify-content-center flex-column">
                                        <h4 className="text-center text-light">Recent Searches</h4>
                                        <div className="d-flex flex-wrap container mt-4">
                                            <SearchCapsules />
                                            <SearchCapsules />
                                            <SearchCapsules />
                                            <SearchCapsules />
                                            <SearchCapsules />
                                            <SearchCapsules />
                                            <SearchCapsules />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="container">
                        <h2 className="my-5 custom-text-color">Latest Blogs</h2>

                        {fitlers.search && <h4 className="custom-text-color mb-5">Search: { fitlers.search } <Icon icon={faXmark} className="text-danger ms-2 cursor-pointer" onClick={() => setFilters({})} /></h4>}
                        <div className="card rounded-4 p-4">
                            <div className="row">
                                {
                                    blogs?.map(( blog, i ) => 
                                        <div className="col-lg-4 col-sm-6" key={i}>
                                            <BlogCard data={blog} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </section>
                </>}
        </>
    )
}
